import { renderQuestions } from '../../../../components/helpers/renderFormQuestions';
import { useEffect, useRef, useState } from 'react';
import { weddingFormPersonQuestions } from '../questions/weddingFormPersonQuestions';
import { errorInput, scrollUp } from '../../../../components/helpers';
import { Message, Icon, Header, Button } from 'semantic-ui-react';
import SignatureCanvas from 'react-signature-canvas';

const StepFillPersonData = (props) => {
  const { setStep, step, inputs, setInputs, person, directions } = props;
  const [errorInputs, setErrorInputs] = useState({});
  const [errorGuestsInputs, set_errorGuestsInputs] = useState({});
  const [dateFocused, set_dateFocused] = useState(null);

  const canvasSign = useRef(null);

  useEffect(() => {
    try {
      canvasSign.current?.clear?.();
      if (inputs[person.gender]?.signature) {
        let sign = inputs[person.gender]?.signature;
        if (typeof sign === 'string') sign = JSON.parse(sign);
        if (sign) canvasSign.current?.fromData?.([sign]);
      }
    } catch (error) {
      console.log('error', error);
    }
  }, [step]);

  const questions = weddingFormPersonQuestions(inputs[person.gender] || {});

  const verifyForm = () => {
    let errorInputs = {};

    let mandatoryInputs = Object.values(questions)
      ?.map((a) => a.id)
      .filter((a) => !!a);

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[person.gender]?.[input] },
      });
    });

    errorInputs = errorInput({
      errorInputs,
      input: { name: 'signature', value: canvasSign.current && !canvasSign.current.isEmpty() },
    });

    setErrorInputs(errorInputs);

    let mandatoryGuestsInputs = {
      guest: ['name', 'lastName', 'identification', 'phone'],
    };

    Object.entries(mandatoryGuestsInputs).forEach(([form, guestInputs]) => {
      guestInputs.forEach((input) => {
        errorGuestsInputs[form] = errorInput({
          errorInputs: errorGuestsInputs[form],
          input: { name: input, value: inputs[person.gender]?.[input] },
        });
      });
    });
    set_errorGuestsInputs(errorGuestsInputs);

    const guestsInputsFlags =
      Object.entries(errorGuestsInputs)?.reduce(
        (acc, [key, value]) => ({ ...acc, [key]: Object.values(value)?.some(Boolean) }),
        {}
      ) || {};

    return Object.values({
      ...errorInputs,
      ...guestsInputsFlags,
    }).includes(true);
  };

  const handleInputs = (event) =>
    setInputs({
      ...inputs,
      [person.gender]: {
        ...(inputs[person.gender] || {}),
        [event.target.name]: event.target.value,
      },
    });

  const saveSignature = () => {
    handleInputs({
      target: {
        name: 'signature',
        value: canvasSign.current?.toData?.()?.flat?.(),
      },
    });
    setErrorInputs((prev) => ({ ...prev, signature: false }));
  };

  const changeStep = (e, direction) => {
    saveSignature();
    if (direction === 'next') {
      if (verifyForm()) return scrollUp();
      setStep(directions?.next);
    } else if (direction === 'prev') {
      setStep(directions?.prev);
    }
  };

  return (
    <div className="read-doc-container">
      <div className="requirements-box">
        <Header as="h2" className="section-header">
          <Icon name="user circle" />
          <Header.Content>
            Datos personales de {person.name}
            <Header.Subheader>Por favor completa todos los campos requeridos</Header.Subheader>
          </Header.Content>
        </Header>

        {Object.values(errorInputs).includes(true) && (
          <Message negative>
            <Message.Header>
              <Icon name="exclamation circle" /> Campos Requeridos
            </Message.Header>
            <p>Por favor completa todos los campos obligatorios antes de continuar.</p>
          </Message>
        )}

        <div className="form-section">
          {renderQuestions({
            questions,
            inputs: inputs[person.gender] || {},
            changeStep,
            handleInputs,
            errorGuestsInputs,
            errorInputs,
            setErrorInputs,
            setErrorGuestsInputs: set_errorGuestsInputs,
            dateFocused,
            set_dateFocused,
            guests: { guest: inputs[person.gender] },
            handleGuests: handleInputs,
          })}
        </div>
        <div>
          <label
            style={{ display: 'block' }}
            className={`${errorInputs['signature'] ? 'error' : ''}`}
            htmlFor={'signature'}
          >
            Firma
          </label>
          <SignatureCanvas
            penColor="black"
            ref={canvasSign}
            canvasProps={{
              width: 300,
              height: 200,
              className: `sigCanvas  ${errorInputs['signature'] ? 'error' : ''}`,
            }}
          />
          <Button
            style={{ display: 'block', margin: '7px' }}
            size="mini"
            onClick={() => canvasSign.current?.clear()}
          >
            Limpiar firma
          </Button>
        </div>
        <div className="navigation-buttons">
          <button className="ui button secondary" onClick={(e) => changeStep(e, 'prev')}>
            <Icon name="arrow left" /> Anterior
          </button>
          <button className="ui button primary" onClick={(e) => changeStep(e, 'next')}>
            Siguiente <Icon name="arrow right" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepFillPersonData;
